var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section-container"},[_c('h2',{staticClass:"line-1"},[_vm._v(_vm._s(_vm.$t('LAYOUT_SECTIONS.SECTION_FAQ.LINE_1')))]),_c('faq',{attrs:{"section":_vm.SECTIONS_FAQ}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }